import { gql, useMutation } from "@apollo/client";
import { Theme } from "./query.theme";

const updateThemeMutation = gql`
  mutation UpdateTheme($input: UpdateThemeInput!) {
    updateTheme(input: $input) {
      primaryFont
      primaryBg
      accent1
      accent2
      accent3
      accent4
      accent5
      accent6
      headerFont
      bodyFont
      headerFontSize
      bodyFontSize
    }
  }
`;

export interface UpdateThemeResponse {
  updateTheme: Theme;
}

export interface UpdateThemeVariables {
  input: {
    overriddenThemeColors?: {
      primaryFont?: string;
      primaryBg?: string;
      accent1?: string;
      accent2?: string;
      accent3?: string;
      accent4?: string;
      accent5?: string;
      accent6?: string;
    };
    overriddenThemeFonts?: {
      header?: string;
      body?: string;
    };
    fontSizes?: {
      header?: number;
      body?: number;
    };
  };
}

export const useUpdateThemeMutation = () =>
  useMutation<UpdateThemeResponse, UpdateThemeVariables>(updateThemeMutation);
